import { render } from "./recurring-cancelled.vue?vue&type=template&id=6f770c1a"
import script from "./recurring-cancelled.vue?vue&type=script&lang=js"
export * from "./recurring-cancelled.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__